import * as z from 'zod';

const birthdayRegex = /^\d{2}-\d{2}-\d{4}$/;

export const signupSchema = z.object({
  first_name: z.string({ error: 'Indtast dit fornavn' }).min(1, { error: 'Indtast dit fornavn' }),
  last_name: z.string({ error: 'Indtast dit efternavn' }).min(1, { error: 'Indtast dit efternavn' }),
  email: z.email({ error: 'Indtast en gyldig emailadresse' }),
  phone_number: z.string({ error: 'Indtast dit mobilnummer' }).min(1, { error: 'Indtast dit mobilnummer' }),
  birthday: z.string({ error: 'Indtast din fødselsdato' })
    .regex(birthdayRegex, { error: 'Indtast dato som dd-mm-åååå' }),
  address: z.object({
    street: z.string({ error: 'Indtast din adresse' }).min(1, { error: 'Indtast din adresse' }),
    postal_code: z.string({ error: 'Indtast postnummer' }).min(1, { error: 'Indtast postnummer' }),
    city: z.string({ error: 'Indtast by' }).min(1, { error: 'Indtast by' }),
  }),
  company: z.string().optional(),
  vat_number: z.string().optional(),
});

export type SignupFormData = z.infer<typeof signupSchema>;
